import { Loader, Stack, VoucherCard } from "components";
import { AppointmentType, Voucher } from "types";
import { useGetUserQuery, useGetVouchersQuery } from "features/api";

const TYPES = {
  now: "CN",
  later: "CL",
};

interface VouchersListProps {
  type: AppointmentType;
  doctor: string;
  active?: Voucher;
  onChange(voucher?: Voucher): void;
}

const VouchersList: React.FC<VouchersListProps> = ({
  type,
  doctor,
  active,
  onChange,
}) => {
  const { data: user } = useGetUserQuery(undefined);
  const { data = [], isLoading } = useGetVouchersQuery(
    user && {
      user: user.id,
      type: TYPES[type],
      doctor,
    },
    {
      refetchOnMountOrArgChange: true
    }
  );
  const vouchers: Voucher[] = data;

  if (isLoading) {
    return (
      <Stack placeContent="center" placeItems="center" style={{ flex: 1 }}>
        <Loader overlay={false} />
      </Stack>
    );
  } else {
    return (
      <Stack direction="column" gap={2}>
        {vouchers.map((voucher) => {
          const isActive = active?.id === voucher.id;
          const handleClick = () => onChange(isActive ? undefined : voucher);

          return (
            <VoucherCard
              key={voucher.id}
              name={voucher.name}
              description={voucher.description}
              discount={voucher.discount}
              count={voucher.count}
              balanceDescription={voucher.balanceDescription}
              available={voucher.available}
              endAt={voucher.endAt}
              active={isActive}
              onClick={handleClick}
            />
          );
        })}
      </Stack>
    );
  }
};

export default VouchersList;
